const submissionStatus = Object.freeze({
  APPROVED: 'approved',
  PENDING: 'pending',
});

export const { APPROVED, PENDING } = submissionStatus;
